import {
    ChangeDetectorRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import {
    FormArray,
    FormGroup,
} from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { ISettings } from '@models';

import {
    Observable,
    ReplaySubject,
    Subject,
} from 'rxjs';
import {
    map,
    switchMap,
} from 'rxjs/operators';

export abstract class UiSettingForm implements OnChanges, OnDestroy {
    @Input()
    public set settings(value: ISettings) {
        this._settings = value;
    }
    public get settings(): ISettings {
        return this._settings;
    }
    @Input()
    public isLoading?: boolean;
    @Input()
    public permission?: string;

    public formGroup!: FormGroup | FormArray;
    public isReadOnly$: Observable<boolean>;

    protected _destroyed$ = new Subject();

    private _settings!: ISettings;
    private _permission$ = new ReplaySubject<string>(1);

    constructor(
        protected _cd: ChangeDetectorRef,
        protected _appState: AppStateFacade,
    ) {
        this.isReadOnly$ = this._permission$
            .pipe(
                switchMap((permission) => this._appState.user.permissions.isGranted(permission)),
                map(isGranted => !isGranted),
            );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.permission) { return; }

        this._permission$.next(changes.permission.currentValue);
    }

    ngOnDestroy() {
        this._destroyed$.next(true);
        this._destroyed$.complete();
    }
}
